import { takeLatest, put, call, take } from 'redux-saga/effects';
import camelCase from 'lodash/camelCase';

import {
  INSURANCE_CARD_SIDE,
  RECORD_TYPE,
  TODO_TYPES,
} from '../../../constants';
import { INSURANCES_CARD_KEYS_MAPPER } from '../../../constants/insurance/insurance-card-keys-mapper';
import { INITIAL_INSURANCE_CARD_STATE } from '../../../constants/insurance/initial-insurance-card-state';

import { checkInsuranceCardOcr } from './check-insurance-card-ocr';

import {
  manageInsurancesActions,
  MANAGE_INSURANCES_ACTION_TYPES,
} from '../actions/manage-insurances-actions';

import {
  actions as updatePatientInsuranceActions,
  consts as updatePatientInsuranceConsts,
} from '../requests/update-patient-insurance';
import {
  actions as createPatientInsuranceActions,
  consts as createPatientInsuranceConsts,
} from '../requests/create-patient-insurance';

const isFrontSideKey = key => key.endsWith('_1');

function* uploadInsuranceCardWorker({ payload }) {
  const {
    fieldName,
    imgValue,
    imgId,
    patientInsuranceId,
    userId,
    handleAdditionalInsuranceFormChange,
    taskAssignmentId,
  } = payload;

  let additionalDataToUpdate = {};

  let createdInsuranceId;

  const { deleted = false, file = '' } = { ...imgValue };

  const data = new FormData();

  const isCardFrontSide = isFrontSideKey(fieldName);

  const key = isCardFrontSide
    ? INSURANCE_CARD_SIDE.FRONT
    : INSURANCE_CARD_SIDE.BACK;

  data.append('userId', userId);

  data.append(key, file);

  data.append('skip_insurance', false);

  if (taskAssignmentId) {
    data.append('todo_task_assignment_id', taskAssignmentId);
    data.append('context', TODO_TYPES.TASK);
  }

  const camelCasedKey = camelCase(key);

  if (file && !imgId) {
    yield put(
      manageInsurancesActions.setUploadInsuranceCardModalData({
        isOpened: true,
        cardType: INSURANCES_CARD_KEYS_MAPPER.get(key),
      }),
    );

    if (patientInsuranceId) {
      data.append('patientInsuranceId', patientInsuranceId);
      yield put(updatePatientInsuranceActions.send(data));

      const result = yield take(updatePatientInsuranceConsts.SUCCEED);

      const { payload: resultPayload } = result;

      const dataToUpdate = {
        [camelCasedKey]: resultPayload[camelCasedKey],
      };

      additionalDataToUpdate = dataToUpdate;

      handleAdditionalInsuranceFormChange(dataToUpdate);
    } else {
      yield put(createPatientInsuranceActions.send(data));

      const result = yield take(createPatientInsuranceConsts.SUCCEED);

      const { payload: resultPayload } = result;

      const additionalSideKey =
        key === INSURANCE_CARD_SIDE.FRONT
          ? INSURANCE_CARD_SIDE.BACK
          : INSURANCE_CARD_SIDE.FRONT;

      const camelCasedAdditionalSideKey = camelCase(additionalSideKey);

      createdInsuranceId = resultPayload.id;

      handleAdditionalInsuranceFormChange({
        [camelCasedKey]: resultPayload[camelCasedKey],
        [camelCasedAdditionalSideKey]:
          resultPayload[camelCasedAdditionalSideKey],
        id: createdInsuranceId,
      });
    }

    if (isCardFrontSide) {
      yield call(checkInsuranceCardOcr, {
        recordId: patientInsuranceId || createdInsuranceId,
        userId,
        handleFormChange: handleAdditionalInsuranceFormChange,
        recordType: RECORD_TYPE.PATIENT_INSURANCE,
        additionalDataToUpdate,
      });
    }
  }

  if (deleted) {
    data.append('patientInsuranceId', patientInsuranceId);

    yield put(updatePatientInsuranceActions.send(data));

    yield take(updatePatientInsuranceConsts.SUCCEED);

    handleAdditionalInsuranceFormChange({
      [camelCasedKey]: INITIAL_INSURANCE_CARD_STATE,
    });
  }

  yield put(
    manageInsurancesActions.setUploadInsuranceCardModalData({
      isOpened: false,
      cardType: null,
    }),
  );
}

export function* uploadInsuranceCard() {
  yield takeLatest(
    MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_INSURANCE_CARD,
    uploadInsuranceCardWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/upload-insurance-card.js